module.exports = __webpack_public_path__ + "static/media/workPvcCeilings2.233608d6.jpg";